import { Form } from "devextreme-react";
import {
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { durationData } from "./data";

import "../index.css";

export default function ScheduleForm(props) {
  const {
    appointmentData,
    // currentEmployeeNo
    currentEmployee,
  } = props;

  const formScheduleRef = useRef(null);

  //   const workRecord = useSelector((state) => state.workRecord);
  const userInfo = useSelector((state) => state.userInfo);

  const onDurationValueChanged = (e) => {
    if (e.value) {
      const formData = formScheduleRef.current.instance.option("formData");

      if (formData.startDate) {
        formScheduleRef.current.instance.updateData(
          "endDate",
          new Date(formData.startDate).getTime() + e.value * 60 * 60 * 1000
        );
      }
    }
  };

  return (
    <Form
      id="form-Schedule"
      ref={formScheduleRef}
      labelMode="outside"
      showColonAfterLabel={false}
      labelLocation="top"
      colCount={4}
      formData={appointmentData}
    >
      <SimpleItem
        dataField={"startDate"}
        editorType="dxDateBox"
        editorOptions={{
          type: "datetime",
          displayFormat: "yyyy-MM-ddTHH:mm:ss",
          dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
          showClearButton: true,
          // readOnly: userInfo.employeeNo == currentEmployeeNo ? false : true,
          readOnly:
            userInfo.employeeNo == currentEmployee.employeeNo ? false : true,
        }}
      >
        <Label text={"Start Date"} />
        <RequiredRule message={`* Start Date를 입력해주세요."`} />
      </SimpleItem>
      <SimpleItem
        dataField={"endDate"}
        editorType="dxDateBox"
        editorOptions={{
          type: "datetime",
          displayFormat: "yyyy-MM-ddTHH:mm:ss",
          dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
          showClearButton: true,
          // readOnly: userInfo.employeeNo == currentEmployeeNo ? false : true,
          readOnly:
            userInfo.employeeNo == currentEmployee.employeeNo ? false : true,
        }}
      >
        <Label text={"End Date"} />
        <RequiredRule message={`* End Date를 입력해주세요."`} />
      </SimpleItem>
      {/* {userInfo.employeeNo == currentEmployeeNo && ( */}
      {userInfo.employeeNo == currentEmployee.employeeNo && (
        <SimpleItem
          dataField={"duration"}
          editorType="dxSelectBox"
          editorOptions={{
            dataSource: durationData,
            valueExpr: "id",
            displayExpr: "name",
            showClearButton: true,
            // readOnly: userInfo.employeeNo == currentEmployeeNo ? false : true,
            onValueChanged: onDurationValueChanged,
          }}
        >
          <Label text="Duration" />
        </SimpleItem>
      )}
      <EmptyItem />
    </Form>
  );
}
